import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GraphqlService } from '../../../../common/services/graphql.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NavigationEnd, Router } from '@angular/router';
import { CommonDataService } from '../../../../common/services/common-data.service';
import { Title } from '@angular/platform-browser';
import { LoginService } from '../../../../common/services/Login.service';
import { SessionService } from '../../../../common/services/Session.service';
import { filter } from 'rxjs/operators';
import scrollIntoView from 'scroll-into-view-if-needed';
import { constObj } from '../../../../common/Constants/constants';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/shared-components/confirm-dialog/confirm-dialog.component';

interface LeftNav {
  item: string;
  itemLink?: string;
  itemData?: LeftNav[];
  guid: string;
  navPath: string;
}

@Component({
  selector: 'app-table-of-content',
  templateUrl: './table-of-content.component.html',
  styleUrls: ['./table-of-content.component.css']
})
export class TableOfContentComponent implements OnInit, AfterViewChecked {
  outcome: boolean = false;

  breadcrumb: string[] = [];
  navData = {
    crumbData: [],
    menuData: [],
  };
  @ViewChild('tree') tree;
  treeControl = new NestedTreeControl<LeftNav>(node => node.itemData);
  dataSource = new MatTreeNestedDataSource<LeftNav>();
  navPathData: any[] = [];
  treeRendered = false;
  constructor(private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService, private browserTitle: Title,
    private loginService: LoginService, private session: SessionService, private cdr: ChangeDetectorRef, public dialog: MatDialog
  ) {
    this.isArchiveApplication(); }
  hasChild = (_: number, node: LeftNav) => !!node.itemData && node.itemData != null;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.isArchiveApplication();
    this.starting = false;
    //if (leftNavigation == undefined || leftNavigation == null) {
    //  this.graphQlService.getNavPathTree(this.router.url.split("/")[1]).subscribe(data => { this.navPathData = data; });
    //}
    //else {
      this.getBreadcrumbWithNavPath(this.router.url.split("/")[1]);
    //}
    this.outcome = true;
    this.commonDataService.showLoader.next(false);
    this.event$
      = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
      .subscribe(() => {
        this.isArchiveApplication();
        this.outcome = false;
        this.commonDataService.showLoader.next(true);
        this.starting = false;

        this.getBreadcrumbWithNavPath(this.router.url.split("/")[1]);

        this.outcome = true;
        this.commonDataService.showLoader.next(false);
      });
  }

  archiveVersion: string = "";
  isArchive: boolean = false;
  isArchiveApplication() {
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.isArchive = true;
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
    }
    //else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId")) {
    //  this.isArchive = true;
    //  this.archiveVersion = localStorage.getItem("ArchiveVersion");
    //  this.commonDataService.loadCurrentLeftNav.next(this.router.url.split("/")[1]);
    //}
    else { this.isArchive = false; }
  }

  tocCreation(navPathData, breadcrumb) {
    this.dataSource.data = navPathData;
    this.treeControl.dataNodes = navPathData;
    this.treeControl.expandAll();
    this.treeRendered = true;

    this.navData.crumbData = breadcrumb;
    //let title = this.router.url.split("/")[1].split("-").length > 1 ? this.navData.crumbData : this.navPathData[0].item;
    //this.browserTitle.setTitle(title);
  }

  setFocus(){
    if( document.getElementById("tableOfContents")!=null){
     let node= document.getElementById("tableOfContents")
      setTimeout(() => {
        scrollIntoView(node, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
      }, 500);
    }
  }

  ngAfterViewInit(){
    this.setFocus();
  }
  event$
  starting: boolean = false;

  ngAfterViewChecked(): void {
    if (!this.starting) {
      if (this.tree && this.tree.treeControl) {
        this.tree.treeControl.expandAll();
      }
      this.cdr.detectChanges();
      this.starting = true;
    }
  }

  navigateToUrl(url: string) {
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    this.router.navigateByUrl(url);
  }

  mainsection: string = "";
  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageNavPath: string }[] = [];
  pagepubllist: { sectionarray: any[], sectionname: string, mainsectionname: string }[] = [];
  showAllInOnePage() {
    let obj = this.dataSource.data[0];
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.mainsection = obj.item;
    this.getpagepublids(obj);
    if (this.pagepublicationId.length > 0) {
      this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
      this.pagepublicationId = [];
    }
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
   
    let navPath: string[] = this.pagepubllist[0].sectionarray[0].pageNavPath.split("-");
    navPath.pop();
    let navPathString: string = navPath.join("/");
    let url = navPathString + '/showallinonepage';
    this.router.navigateByUrl(url);
  }
  getpagepublids(obj) {
    //if (obj.itemData.length > 0 && obj.rollUp != 'True') {
    //  for (let items of obj.itemData) {
    //    this.getpagepublids(items);
    //  }
    //}
    //if ((obj.itemData.length == 0 || obj.rollUp == 'True') && obj.itemLink != null) {
    //  if (obj.itemLink != null) {
    //    let PublpageId = obj.itemLink.split('/').map(d => d);
    //    let pageTitle = obj.item;
    //    this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageNavPath: obj.navPath });
    //  }
    //}
    if (obj.itemData.length > 0 && obj.rollUp != 'True') {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
      }
    }
    if (obj.itemLink != null && (obj.itemData?.length == 0 || obj.rollUp == 'True')) {
      let PublpageId = obj.itemLink.split('/').map(d => d);
      let pageTitle = obj.item;
      this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageNavPath: obj.navPath });
    }
    else {
      if (this.pagepublicationId.length > 0) {
        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  //updateSEClinksOnPageNavDataUpdate() {
  //  if (localStorage.getItem("DefaultSecView") === "false") {
  //    let navPathDataWithoutSec = JSON.parse(JSON.stringify(this.navPathData));

  //    if (navPathDataWithoutSec[0].itemData[0].itemData === null) {
  //      navPathDataWithoutSec[0].itemData = navPathDataWithoutSec[0].itemData.filter(x => x.item[0] !== 'S');
  //    }
  //    else {
  //      let dataLength1 = navPathDataWithoutSec[0].itemData.length;
  //      for (let i = 0; i < dataLength1; i++) {
  //        navPathDataWithoutSec[0].itemData[i].itemData = navPathDataWithoutSec[0].itemData[i].itemData.filter(x => x.item[0] !== 'S');
  //      }
  //    }
  //    this.dataSource.data = null;
  //    this.dataSource.data = navPathDataWithoutSec;
  //    this.treeControl.dataNodes = navPathDataWithoutSec;
  //    this.treeControl.expandAll();
  //  }
  //  else {
  //  this.dataSource.data = null;
  //  this.dataSource.data = this.navPathData;
  //  this.treeControl.dataNodes = this.navPathData;
  //  this.treeControl.expandAll();
  //  }
  //}


  BreadcrumbData: any[] = [];
  getBreadcrumbWithNavPath(breadcerumbUrl) {
    this.BreadcrumbData = [];
    this.navPathData = [];
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      if (leftNavigation[i].itemData.length != 0 && leftNavigation[i].rollUp != "True") {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j]?.guid == breadcerumbUrl) {
            this.BreadcrumbData.push(leftNavigation[i].item)
            this.BreadcrumbData.push(leftNavigation[i].itemData[j].item)
            this.getTreeNodes(leftNavigation[i].itemData[j], this.BreadcrumbData);
          } else {
            if (leftNavigation[i].itemData[j].itemData.length != 0 && leftNavigation[i].itemData[j].rollUp != "True") {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k]?.guid == breadcerumbUrl) {
                  this.BreadcrumbData.push(leftNavigation[i].item)
                  this.BreadcrumbData.push(leftNavigation[i].itemData[j].item)
                  this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].item)
                  this.getTreeNodes(leftNavigation[i].itemData[j].itemData[k], this.BreadcrumbData);
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData.length != 0 && leftNavigation[i].itemData[j].itemData[k].rollUp != "True") {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.guid == breadcerumbUrl) {
                        this.BreadcrumbData.push(leftNavigation[i].item)
                        this.BreadcrumbData.push(leftNavigation[i].itemData[j].item)
                        this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].item)
                        this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item)
                        this.getTreeNodes(leftNavigation[i].itemData[j].itemData[k].itemData[l], this.BreadcrumbData);
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length != 0 && leftNavigation[i].itemData[j].itemData[k].itemData[l].rollUp != "True") {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.guid == breadcerumbUrl) {
                              this.BreadcrumbData.push(leftNavigation[i].item)
                              this.BreadcrumbData.push(leftNavigation[i].itemData[j].item)
                              this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].item)
                              this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item)
                              this.BreadcrumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item)
                              this.getTreeNodes(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m], this.BreadcrumbData);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  BackToCurrentContent() {
    let popUpMessage = constObj.currentVersionNavigationAlert;
    popUpMessage += "<br/>" + constObj.continueMessage;
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home");
      }
    });
  }

  navPathtreeNodes: any[] = [];
  getTreeNodes(item, BreadcrumbData) {
    let itemData = item.itemData;
    for (let i = 0; i < itemData.length; i++) {
      if (itemData[i].rollUp == 'True') {
        itemData[i].itemData = [];
      }
      else {
        for (let j = 0; j < itemData[i].itemData.length; j++) {
          if (itemData[i].itemData[j].rollUp == 'True') {
            itemData[i].itemData[j].itemData = [];
          }
          else {
            for (let k = 0; k < itemData[i].itemData[j].itemData.length; k++) {
              if (itemData[i].itemData[j].itemData[k].rollUp == 'True') {
                itemData[i].itemData[j].itemData[k].itemData = [];
              }
              else {
                for (let l = 0; l < itemData[i].itemData[j].itemData[k].itemData.length; l++) {
                  if (itemData[i].itemData[j].itemData[k].itemData[l].rollUp == 'True') {
                    itemData[i].itemData[j].itemData[k].itemData[l].itemData = [];
                  }
                  else {
                    for (let m = 0; m < itemData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                      if (itemData[i].itemData[j].itemData[k].itemData[l].itemData[m].rollUp == 'True') {
                        itemData[i].itemData[j].itemData[k].itemData[l].itemData[m].itemData = [];
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.navPathtreeNodes.push(item);
    this.tocCreation(this.navPathtreeNodes, BreadcrumbData)
  }
}
